import { create } from 'zustand'
import { INotification } from '../../interfaces/src'

export interface NotificationState {
  notifications: INotification[] | null
  isLoading: boolean
  isErrorGetNotifications: {
    status: boolean
    message: string
  }
  metadata: {
    unread: number
    totalNotifications: number
    page: number
    pages: number
  }
  setNotifications: (notifications: INotification[] | null) => void
  setIsLoading: (isLoading: boolean) => void
  setIsErrorGetNotifications: ({
    status,
    message
  }: {
    status: boolean
    message: string
  }) => void
  handleUpdateNotification: (notificationId: number) => void
  setUnreadNotifications: (unread: number) => void
  setMetadata: (metadata: NotificationState['metadata']) => void
  reset: () => void
}

const initialState = {
  metadata: {
    pages: 1,
    page: 0,
    unread: 0,
    totalNotifications: 0
  },
  isErrorGetNotifications: {
    status: false,
    message: ''
  },
  isLoading: false,
  notifications: null
}

export const useNotificationStore = create<NotificationState>()((set) => ({
  ...initialState,
  setNotifications: (notifications) => set({ notifications }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setIsErrorGetNotifications: (isErrorGetNotifications) =>
    set({ isErrorGetNotifications }),
  setMetadata: (metadata) => set({ metadata }),
  setUnreadNotifications: (unread) => {
    set((state) => ({
      ...state,
      metadata: {
        ...state?.metadata,
        unread
      }
    }))
  },
  handleUpdateNotification: (notificationId) => {
    set((state) => {
      if (!state?.notifications) {
        return state
      }

      const updatedNotifications = state?.notifications?.map((notification) => {
        if (notification?.notificationId === notificationId) {
          return {
            ...notification,
            read: true
          }
        }

        return notification
      })

      return {
        ...state,
        notifications: updatedNotifications,
        metadata: {
          ...state?.metadata,
          unread: state?.metadata?.unread
            ? state?.metadata?.unread - 1
            : state?.metadata?.unread
        }
      }
    })
  },
  reset: () => set({ ...initialState })
}))
